<template>
  <tab-item-template>
    <template #toolbar-items>
      <v-spacer/>
      <trade-contract-filter
          class="mr-2"
          @change="handleFilterChanged"
          hide-status-filters
          hide-direction-filters>
      </trade-contract-filter>
    </template>

    <div style="position: relative;">
      <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="15"
          class="py-3">
      </v-pagination>
      <el-table
          :data="dataImplementationsWithMessagesCounts"
          border>

        <el-table-column
            width="120"
            prop="id"
            label="データ実装ID">
        </el-table-column>

        <el-table-column
            min-width="35"
            prop="dataComponentModel.name"
            label="データ実装名">
        </el-table-column>

        <el-table-column
            min-width="35"
            prop="localId"
            label="内部ID">
          <template #default="{row}">
            <table-inline>
              <local-id-field
                  :value="row.localId">
              </local-id-field>
            </table-inline>
          </template>
        </el-table-column>

        <el-table-column
            width="80"
            prop="messagesCount"
            label="取引数">
        </el-table-column>

        <el-table-column
            width="160"
            prop="createdAt"
            label="登録日時">
          <template #default="{row}">{{ formatDateTime(row.createdAt) }}</template>
        </el-table-column>

        <el-table-column
            width="60"
            align="center"
            fixed="right">
          <template #default="{row}">
            <icon-btns>
              <icon-btn
                  type="view"
                  :to="{ name: '/edit/list/tradeResultForData/TradeResultShowForData', params: { dataImplementationId: row.id } }">
              </icon-btn>
            </icon-btns>
          </template>
        </el-table-column>
      </el-table>
      <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="15"
          class="py-3">
      </v-pagination>
      <v-overlay
          :value="loading"
          z-index="3"
          absolute>
        <v-progress-circular
            indeterminate
            size="64">
        </v-progress-circular>
      </v-overlay>
    </div>
  </tab-item-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import Formatter from "@/utils/Formatter";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import LocalIdField from "@/components/molecules/LocalIdField.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import IoablePageMixin from "@/router/IoablePageMixin";
import {mapState} from "vuex";
import TradeContractFilter from "@/components/organisms/TradeContractFilter.vue";

export default {
  name: 'TradeContractTableForData',
  mixins: [
    IoablePageMixin,
    PathInfoMixin,
    Formatter
  ],
  components: {
    TradeContractFilter,
    LocalIdField,
    TableInline,
    IconBtn,
    IconBtns,
    TabItemTemplate
  },
  data() {
    return {
      queryForm: {
        role: undefined
      },
      page: 1,
      pageCount: 0,
      perPage: 10,
      loading: true,
    }
  },
  computed: {
    ...mapState('hcs/dataImplementationsWithMessagesCount', ['dataImplementationsWithMessagesCounts']),
  },
  methods: {
    async load() {
      try {
        this.loading = true;
        const result = await this.$store.dispatch('hcs/dataImplementationsWithMessagesCount/findList', {
          ...this.queryForm,
          page: this.page,
          perPage: this.perPage,
        });
        this.page = result.page;
        this.pageCount = Math.ceil(result.total / result.perPage);
      } finally {
        this.loading = false;
      }
    },
    handleFilterChanged(filters) {
      const {showProduce, showConsume} = filters;

      this.$set(this.queryForm, 'role', (() => {
        if(showProduce && showConsume) {
          return undefined;
        } else if(showProduce && !showConsume) {
          return 'producer';
        } else if(!showProduce && showConsume) {
          return 'consumer';
        }
      })());
    }
  },
  watch: {
    page: {
      handler() {
        this.load();
      }
    },
    queryForm: {
      deep: true,
      handler() {
        this.page = 1;
        this.load();
      }
    }
  }
}
</script>
